// extracted by mini-css-extract-plugin
export default {"container":"MyTransactionsComponent_container__8Nnvk"};